"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _Button = _interopRequireDefault(require("@react/react-spectrum/Button"));

var _A11yContext = require("../context/A11yContext");

var _useIngest = _interopRequireDefault(require("../hooks/useIngest"));

var _CommentsDelete = _interopRequireDefault(require("../style/CommentsDelete.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/

/**
 * Delete dialog component.
 * @return {ReactElement} markup
 */
function Delete(_ref) {
  var _ref$commentProposedF = _ref.commentProposedForDelete,
      commentProposedForDelete = _ref$commentProposedF === void 0 ? {} : _ref$commentProposedF,
      isDeleting = _ref.isDeleting,
      onCancel = _ref.onCancel,
      onDelete = _ref.onDelete;
  var parentCommentId = commentProposedForDelete.parentCommentId;
  var isReply = !!commentProposedForDelete.parentCommentId;
  var ccxIngest = (0, _useIngest.default)();
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    // trap focus
    ref.current.focus();
    ccxIngest.fireEvent({
      event: {
        context_guid: parentCommentId,
        subcategory: parentCommentId ? 'delete-reply' : 'delete-comment',
        subtype: 'overlay',
        type: 'render'
      }
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  var handleCancel = function handleCancel() {
    ccxIngest.fireEvent({
      event: {
        context_guid: parentCommentId,
        subcategory: parentCommentId ? 'delete-reply' : 'delete-comment',
        subtype: 'cancel',
        type: 'click'
      }
    });
    onCancel();
  };

  var handleDelete = function handleDelete() {
    ccxIngest.fireEvent({
      event: {
        context_guid: parentCommentId,
        subcategory: parentCommentId ? 'delete-reply' : 'delete-comment',
        subtype: 'confirm-delete',
        type: 'click'
      }
    });
    onDelete();
  };
  /**
   * Handles keydown event.
   * @param {SyntheticEvent} event - event object
   * @return {undefined}
   */


  var handleKeyDown = function handleKeyDown(event) {
    switch (event.key) {
      case 'Esc':
      case 'Escape':
        onCancel();
        break;

      case 'Tab':
        (0, _A11yContext.focusNextTrappedElement)(ref.current, event);
        break;

      default:
        break;
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    role: "dialog",
    "aria-labelledby": "delete-dialog-heading",
    "aria-describedby": "delete-dialog-message",
    ref: ref,
    className: _CommentsDelete.default.component,
    id: "comment-delete-view",
    onKeyDown: handleKeyDown,
    tabIndex: "0"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "delete-background"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "delete-wrapper"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    id: "delete-dialog-heading",
    className: "delete-header"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: isReply ? 'comments.delete.header_reply' : 'comments.delete.header_comment'
  })), /*#__PURE__*/_react.default.createElement("p", {
    id: "delete-dialog-message",
    className: "delete-message"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: isReply ? 'comments.delete.message_reply' : 'comments.delete.message_comment'
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "button-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    quiet: true,
    variant: "secondary",
    onClick: handleCancel,
    disabled: isDeleting
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "comments.delete.cancel"
  })), /*#__PURE__*/_react.default.createElement(_Button.default, {
    quiet: true,
    variant: "warning",
    onClick: handleDelete,
    disabled: isDeleting
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "comments.delete.confirm_delete"
  }))))));
}

Delete.defaultProps = {
  onCancel: function onCancel() {},
  onDelete: function onDelete() {}
};
Delete.propTypes = {
  assetData: _propTypes.default.shape({
    id: _propTypes.default.string,
    ownerId: _propTypes.default.string,
    region: _propTypes.default.string
  }),
  ccxIngest: _propTypes.default.object,
  commentProposedForDelete: _propTypes.default.object,
  isDeleting: _propTypes.default.bool,
  onCancel: _propTypes.default.func,
  onDelete: _propTypes.default.func
};
var _default = Delete;
exports.default = _default;